<template>
  <div class="common-header">
<!--    <img src="../../assets/mobile/header-img-1.jpg" alt="">-->
    <img src="../../assets/mobile/header-img-2.jpg" alt="">
  </div>
</template>

<script>
export default {
  name: "CommonHeader"
}
</script>

<style lang="less">
@import "../../common/theme";
.mobile-home {
  .common-header {
    padding: calc(@mobileFont * .15) calc(@mobileFont * .55);
    img {
      vertical-align: middle;
      width: calc(@mobileFont * 1.68);
      margin-right: calc(@mobileFont * .2);
    }
  }
}
</style>
